module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3UdxM"))).then(() => parcelRequire('5erN3'));